import { render } from "./bottom-nav-simple.vue?vue&type=template&id=43e11470&scoped=true"
import script from "./bottom-nav-simple.vue?vue&type=script&lang=js"
export * from "./bottom-nav-simple.vue?vue&type=script&lang=js"

import "./bottom-nav-simple.vue?vue&type=style&index=0&id=43e11470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e11470"]])

export default __exports__